//	Prevents a particular binder from running too quickly, (using a timeout and an optional grouping of methods)
//	Usage: In the constructor of your component, decorate the method, eg:
//
//      this.myMethod = preventableBinder(this.myMethod.bind(this), 'optionalGroup')
//      this.myOtherMethod = preventableBinder(this.myOtherMethod.bind(this), 'optionalGroup')
//
//  This will prevent either method from running more than once in 333ms.
//  This is useful for scenarious where you may bind onClick and onTouchStart, and not want a double event

const preventableBinderGroup = {}

const preventableBinder = (binder, group = 'default', timeout = 333) => {
	preventableBinderGroup[group] = false
	return (...bindRest) => {
		const func = binder(...bindRest)
		return (...rest) => {
			if (!preventableBinderGroup[group]) {
				preventableBinderGroup[group] = true
				setTimeout(() => {
					preventableBinderGroup[group] = false
				}, timeout)
				return func(...rest)
			}
			return []
		}
	}
}

export default preventableBinder



// WEBPACK FOOTER //
// ./src/utilities/preventableBinder.js